import { GET_SETTINGS, SET_APP_MODE } from "./actionTypes";
import { GET_SETTINGS_URL } from "../../configs";
import Axios from "axios";

export const getSettings = () => (dispatch) => {
  Axios.post(GET_SETTINGS_URL)
    .then((response) => {
      const settings = response.data;
      
      // Store settings in localStorage
      if (settings && typeof settings === 'object') {
        Object.keys(settings).forEach(key => {
          if (settings[key] !== null && settings[key] !== undefined) {
            localStorage.setItem(key, settings[key]);
          }
        });
      }
      
      return dispatch({ type: GET_SETTINGS, payload: settings });
    })
    .catch(function(error) {
      console.log(error);
    });
};

export const setAppMode = (mode) => (dispatch) => {
  // Save to localStorage for persistence across page reloads
  localStorage.setItem('appMode', mode.toString());
  // console.log('🔄 App mode saved to localStorage:', mode);
  
  return dispatch({ type: SET_APP_MODE, payload: mode });
}

export const initializeAppMode = () => (dispatch) => {
  const savedMode = localStorage.getItem('appMode');
  if (savedMode) {
    const mode = parseInt(savedMode, 10);
    console.log('🔄 Initializing app mode from localStorage:', mode);
    return dispatch({ type: SET_APP_MODE, payload: mode });
  }
  console.log('🔄 No saved app mode found, keeping default');
  return Promise.resolve();
}
